module.exports = __webpack_public_path__ + "img/outlander_in.aaf31efe.jpg";